import React from 'react';

import styled from 'styled-components';

import DetailsButton from 'components/lib/DetailsButton';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 9px;
`;

type Props = {
  onClick: () => void;
};

const DetailsCell = ({ onClick }: Props) => (
  <Container>
    <DetailsButton onClick={onClick} />
  </Container>
);

export default DetailsCell;
